__turbopack_context__.v({
  "fade": "bmrjda_fade",
  "fadeFast": "bmrjda_fadeFast",
  "maxH": "bmrjda_maxH",
  "phoneScreen": "bmrjda_phoneScreen",
  "root": "bmrjda_root",
  "slideX": "bmrjda_slideX",
  "slideY": "bmrjda_slideY",
  "tone": "bmrjda_tone",
  "width": "bmrjda_width",
});
